function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, DropdownMenu, SearchInput } from '@deephaven/components';
import { vsGraph, vsTriangleDown } from '@deephaven/icons';
import { useDebouncedCallback } from '@deephaven/react-hooks';
import { EMPTY_FUNCTION } from '@deephaven/utils';
import { ObjectIcon } from "./common/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RESET_FILTER_DELAY = 5000;
function ConsoleObjectsMenu(_ref) {
  var openObject = _ref.openObject,
    objects = _ref.objects;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    filterText = _useState2[0],
    setFilterText = _useState2[1];
  var searchRef = useRef(null);
  var resetFilter = useDebouncedCallback(() => {
    setFilterText('');
  }, RESET_FILTER_DELAY);
  var handleMenuOpen = useCallback(() => {
    var _searchRef$current;
    resetFilter.cancel();
    (_searchRef$current = searchRef.current) === null || _searchRef$current === void 0 || _searchRef$current.select();
  }, [resetFilter]);
  var handleMenuClose = useCallback(() => {
    resetFilter();
  }, [resetFilter]);
  var actions = useMemo(() => {
    if (objects.length === 0) {
      return [];
    }
    var searchActions = {
      menuElement: /*#__PURE__*/_jsx(SearchInput, {
        value: filterText,
        onChange: e => {
          setFilterText(e.target.value);
        },
        className: "console-menu",
        ref: searchRef
      })
    };
    var filteredObjects = filterText ? objects.filter(_ref2 => {
      var title = _ref2.title;
      return title != null && title.toLowerCase().includes(filterText.toLowerCase());
    }) : objects;
    var objectActions = filteredObjects.map(object => ({
      title: object.title,
      action: () => {
        openObject(object);
      },
      icon: /*#__PURE__*/_jsx(ObjectIcon, {
        type: object.type
      })
    }));
    return [searchActions, ...objectActions];
  }, [objects, filterText, openObject]);
  return /*#__PURE__*/_jsx(Button, {
    "aria-label": "Objects",
    kind: "ghost",
    disabled: objects.length === 0
    // no-op: click is handled in `DropdownMenu`
    ,
    onClick: EMPTY_FUNCTION,
    tooltip: objects.length === 0 ? 'No objects available' : 'Objects',
    icon: /*#__PURE__*/_jsxs("div", {
      className: "fa-md fa-layers",
      children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
        mask: vsGraph,
        icon: vsTriangleDown,
        transform: "right-5 down-5"
      }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: vsTriangleDown,
        transform: "right-8 down-6"
      })]
    }),
    children: /*#__PURE__*/_jsx(DropdownMenu, {
      actions: actions,
      onMenuOpened: handleMenuOpen,
      onMenuClosed: handleMenuClose,
      options: {
        initialKeyboardIndex: 1
      },
      popperOptions: {
        placement: 'bottom-end'
      }
    })
  });
}
export default ConsoleObjectsMenu;
//# sourceMappingURL=ConsoleObjectsMenu.js.map